module.exports = __webpack_public_path__ + "img/no-content.28593a5f.svg";